export default "__VITE_ASSET__BDOKHzqk__"